const availableLanguages = ['nl', 'fr', 'en', 'hr'];
export default availableLanguages;